export default {
  clientId: "660cf4c5-6c3c-4300-baff-229b93a8bdeb",
  authority:
    "https://login.microsoftonline.com/5db8bf0e-8592-4ed0-82b2-a6d4d77933d4",
  redirectUri: process.env.VUE_APP_APP_URL,
};
